import {asset} from 'imba';
import url from './blob9.svg';
export default asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"viewBox":"0 0 409 321","width":"409","height":"321","fill":"none"},"flags":[],"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M255 287.2C163.5 301.7 30 362.5 4 273.7c-25.8-88.8 75-144.5 151.3-196.6 63.6-43.4 165-106 228.4-62.3 63.6 44-9.2 135.6-42.2 205.5-17.3 36.5-46.8 60.6-86.6 67z\" fill=\"currentColor\"/>"},
	toString: function(){ return this.url;}
})